module.exports = __webpack_public_path__ + "img/ghost.d7cc668a.svg";